import { Component } from '@angular/core';
import * as moment from 'moment-timezone';


@Component({
  templateUrl: 'demo-page.html',
  styleUrls: ['demo-page.scss'],
})
export class DemoPageComponent {

  time:string;

  constructor() {
    this.time = moment().tz('America/New_York').format('h:mma z');
  }


}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/demo-page/demo-page.ts